import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { ComponentType } from 'react';
import { getRuntimeConfig } from './runtimeConfig';

const defaultBrowserHistory = {
  url: '/',
  location: { pathname: '' },
  state: { url: '' },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  listen: () => {},
};

let browserHistory = defaultBrowserHistory;

if (typeof window !== 'undefined') {
  browserHistory = { ...browserHistory, ...window.history };
  browserHistory.location.pathname = browserHistory?.state?.url;
}

const reactPlugin = new ReactPlugin();

const connectionString = getRuntimeConfig().appInsightsConnectionString;

const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

try {
  connectionString && appInsights.loadAppInsights();
} catch (e) {
  console.error('AppInsights init failed:', e);
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (Component: ComponentType<unknown>) => withAITracking(reactPlugin, Component);
export { reactPlugin, appInsights };
